import React from "react";
import { cn } from "@/lib/utils";

export function ProjectCardSkeleton({ className }) {
  return (
    <div className={cn("group relative h-full", className)}>
      {/* Glow backdrop matching real card */}
      <div className="absolute -inset-1 rounded-3xl bg-gradient-to-r from-primary/15 via-primary/5 to-transparent opacity-60 blur-xl pointer-events-none" />

      {/* Glass card container with exact dimensions and padding */}
      <div className="animate-shimmer relative h-full rounded-3xl border border-white/10 bg-white/[0.02] p-6 backdrop-blur-md shadow-[0_18px_50px_rgba(0,0,0,0.4)] flex flex-col gap-5">
        {/* Header: Category Badge & Icon */}
        <div>
          <div className="flex items-start justify-between gap-4 mb-4">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-3 py-1">
              <span className="h-1.5 w-1.5 rounded-full bg-primary/40 animate-pulse" />
              <div className="h-3 w-20 rounded bg-primary/20 animate-pulse" />
            </div>
            <div className="h-10 w-10 rounded-xl border border-white/10 bg-white/[0.05] animate-pulse" />
          </div>

          {/* Title & Client placeholder */}
          <div className="min-h-[3.75rem] flex flex-col justify-center gap-2">
            <div className="h-6 w-3/4 rounded-lg bg-white/[0.08] animate-pulse" />
            <div className="flex items-center gap-2">
              <div className="h-3.5 w-3.5 rounded-full bg-white/10 animate-pulse" />
              <div className="h-3.5 w-1/3 rounded bg-white/[0.05] animate-pulse" />
            </div>
          </div>
        </div>

        {/* Challenge Box Skeleton */}
        <div className="rounded-xl border border-orange-500/20 bg-gradient-to-br from-orange-500/5 to-transparent p-4">
          <div className="mb-2 flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-orange-400/20 animate-pulse" />
            <div className="h-3 w-16 rounded bg-orange-400/20 animate-pulse" />
          </div>
          <div className="h-[4.5rem] flex flex-col justify-around py-0.5">
            <div className="h-3 w-full rounded bg-white/[0.06] animate-pulse" />
            <div className="h-3 w-11/12 rounded bg-white/[0.05] animate-pulse" />
            <div className="h-3 w-2/3 rounded bg-white/[0.04] animate-pulse" />
          </div>
        </div>

        {/* Solution Box Skeleton */}
        <div className="rounded-xl border border-green-500/20 bg-gradient-to-br from-green-500/5 to-transparent p-4">
          <div className="mb-2 flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-green-400/20 animate-pulse" />
            <div className="h-3 w-16 rounded bg-green-400/20 animate-pulse" />
          </div>
          <div className="h-[4.5rem] flex flex-col justify-around py-0.5">
            <div className="h-3 w-full rounded bg-white/[0.06] animate-pulse" />
            <div className="h-3 w-4/5 rounded bg-white/[0.05] animate-pulse" />
            <div className="h-3 w-3/5 rounded bg-white/[0.04] animate-pulse" />
          </div>
        </div>

        {/* Tech Stack Skeleton */}
        <div>
          <div className="h-3 w-20 rounded bg-white/10 animate-pulse mb-2.5" />
          <div className="flex items-center gap-1.5 flex-nowrap overflow-hidden">
            <div className="h-6 w-16 rounded-lg border border-primary/20 bg-primary/5 animate-pulse shrink-0" />
            <div className="h-6 w-20 rounded-lg border border-primary/20 bg-primary/5 animate-pulse shrink-0" />
            <div className="h-6 w-14 rounded-lg border border-primary/20 bg-primary/5 animate-pulse shrink-0" />
          </div>
        </div>

        {/* Action Buttons Skeleton */}
        <div className="mt-auto pt-2 flex gap-2.5">
          <div className="h-10 flex-1 rounded-xl border border-white/15 bg-white/[0.06] animate-pulse" />
          <div className="h-10 flex-1 rounded-xl border border-primary/30 bg-primary/10 animate-pulse" />
        </div>
      </div>
    </div>
  );
}

export default ProjectCardSkeleton;
